import React from "react";

const OrderHistoryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        d="M16.4101 5.11523H17.7043L18.9985 16.5113C19.0229 16.7554 18.7421 16.9658 18.388 16.9658L1.61196 16.9995C1.25788 16.9995 0.977061 16.7891 1.00148 16.545L2.19801 5.14891H3.54109"
        stroke="#3F3F3F"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5263 6.0166H8.43726"
        stroke="#3F3F3F"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.968 7.40505V3.81114C13.968 2.25407 12.1854 1 9.9877 1C7.78996 1 6.00732 2.26248 6.00732 3.81114V7.40505"
        stroke="#3F3F3F"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OrderHistoryIcon;
